import React, { Component } from "react"
import { css } from "emotion"
import { Link } from "gatsby"
import lazyLoadImages from "../utilities/lazy-load-images"

class Footer extends Component {
  componentDidMount() {
    lazyLoadImages()
  }

  render() {
    return (
      <footer
        className={css`
          background: red;
          padding: 20px;
        `}
      >
        <div
          className={css`
            max-width: 1200px;
            margin: 0 auto;
            text-align: center;
          `}
        >
          <nav
            className={css`
              a {
                padding: 20px 10px;
                font-size: 16px;
                color: #fff;
                text-decoration: none;
              }
            `}
          >
            <Link to="/">Home</Link>
            <Link to="/recipes">Recipes</Link>
            <Link to="/reviews">Reviews</Link>
            <Link to="/about-us">About</Link>
          </nav>

          <ul
            className={css`
              display: flex;
              justify-content: center;
              align-items: center;
              flex-flow: row wrap;
              list-style: none;
              margin-top: 20px;

              li {
                margin: 20px 15px;
                flex: 0 1 auto;
              }

              li img {
                width: 50px;
              }
            `}
          >
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/chefvscake/"
              >
                <img
                  src="/resources/images/social-icons/facebook.svg"
                  alt="Like us on Facebook"
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/channel/UC7tVnvHpDHzAdF3so-3aQoQ/videos"
              >
                <img src="/resources/images/social-icons/youtube.svg" alt="" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.pinterest.com/vscake/"
              >
                <img
                  src="/resources/images/social-icons/pinterest.svg"
                  alt=""
                />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/chefvscake"
              >
                <img src="/resources/images/social-icons/twitter.svg" alt="" />
              </a>
            </li>
          </ul>

          <p
            className={css`
              padding: 20px 0px;
              color: #fff;
              font-size: 14px;
            `}
          >
            &copy; 2019 OnlineCakeClasses.com
          </p>

          <p
            className={css`
              font-size: 12px;
              color: #fff;

              a {
                color: #fff;
                text-decoration: none;
              }
            `}
          >
            Site Developed by{" "}
            <a
              href="http://ravigoswami.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              Ravi Goswami
            </a>
          </p>
        </div>
      </footer>
    )
  }
}

export default Footer
